import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import {withRouter} from "../../lib/react/withRouter";
import sso from "../../sso";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Pms_Bel extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.paa = [];
    this.state.aa = [];

    this.state.mna = [];
    this.state.mna.push({ mnid: "mn01", pos: "c1", text: "RUMSTYP", desc: "Rumstyps beläggning", link: "/pms/bel/rt" });
    this.state.mna.push({ mnid: "mn02", pos: "c1", text: "RUM", desc: "Rums beläggning", link: "/pms/bel/room" });
    this.state.mna.push({ mnid: "mn03", pos: "c1", text: "KONFERENS", desc: "Konferens beläggning", link: "/pms/bel/kf" });
    this.state.mna.push({ mnid: "mn04", pos: "c1", text: "RESURS", desc: "Resurs beläggning", link: "/pms/bel/rs" });
    this.state.mna.push({ mnid: "mn05", pos: "c2", text: "PAKET", desc: "Paket beläggning", link: "/pms/bel/pk" });
    this.state.mna.push({ mnid: "mn06", pos: "c2", text: "ROOMRACK", desc: "Roomrack", link: "/pms/bel/rr" });
    this.state.mna.push({ mnid: "mn07", pos: "c2", text: "ANK / BO / AVR", desc: "Ankommande Boende Avresande", link: "/pms/bel/aba" });
    this.state.mna.push({ mnid: "mn07", pos: "c2", text: "BOKAT FRÅN / TILL", desc: "Bokat valt datum", link: "/pms/bel/bft" });
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 480;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }
    mnc(pos) {
        var mna = [];
        for(var row of this.state.mna) {
            if(row.pos == pos) mna.push( row );
        }
        return mna;
    }

  fknGo(url) {
    //alert(row.href);
    var row = {};
    row.url = url;
    sso.seo.sfkn = row;
    this.props.navigate(url);
  }

  render() {
    return (
    <div className="web-app">
        <div className="web-pg py-4 flex">
            <h3>Beläggning</h3>
            <p>Beläggnings funktioner</p>

            <div className="divider_green"></div>

            <div className="web-row">
                
                <div className="flex-col flex">
                    { this.mnc("c1").map((row, key) =>
                        <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="flex-col flex">
                    { this.mnc("c2").map((row, key) =>
                        <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>

            </div>
        </div>

    </div>
  );
    }
}
export default withRouter(Pms_Bel);
